export default __webpack_public_path__ + "static/media/community_default_with_bg.8754aefe.svg";